// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SimulateRainfallStandardEventsInput } from "./SimulateRainfallStandardEventsInput";
import {
  SimulateRainfallStandardEventsInputFromJSON,
  SimulateRainfallStandardEventsInputFromJSONTyped,
  SimulateRainfallStandardEventsInputToJSON,
  SimulateRainfallStandardEventsInputToJSONTyped,
} from "./SimulateRainfallStandardEventsInput";
import type { SimulateRainfallStandardEventsOutput } from "./SimulateRainfallStandardEventsOutput";
import {
  SimulateRainfallStandardEventsOutputFromJSON,
  SimulateRainfallStandardEventsOutputFromJSONTyped,
  SimulateRainfallStandardEventsOutputToJSON,
  SimulateRainfallStandardEventsOutputToJSONTyped,
} from "./SimulateRainfallStandardEventsOutput";

/**
 *
 * @export
 * @interface SimulateRainfallStandardEventsSchema
 */
export interface SimulateRainfallStandardEventsSchema {
  /**
   *
   */
  tag: SimulateRainfallStandardEventsSchemaTagEnum;
  /**
   *
   */
  inputs: SimulateRainfallStandardEventsInput;
  /**
   *
   */
  outputs: SimulateRainfallStandardEventsOutput;
}

/**
 * @export
 */
export const SimulateRainfallStandardEventsSchemaTagEnum = {
  SimulateRainfallStandardEvents: "simulate_rainfall_standard_events",
} as const;
export type SimulateRainfallStandardEventsSchemaTagEnum =
  (typeof SimulateRainfallStandardEventsSchemaTagEnum)[keyof typeof SimulateRainfallStandardEventsSchemaTagEnum];

/**
 * Check if a given object implements the SimulateRainfallStandardEventsSchema interface.
 */
export function instanceOfSimulateRainfallStandardEventsSchema(
  value: object
): value is SimulateRainfallStandardEventsSchema {
  if (!("tag" in value) || value["tag"] === undefined) return false;
  if (value["tag"] !== "simulate_rainfall_standard_events") return false;

  if (!("inputs" in value) || value["inputs"] === undefined) return false;
  if (!("outputs" in value) || value["outputs"] === undefined) return false;
  return true;
}

export function SimulateRainfallStandardEventsSchemaFromJSON(
  json: any
): SimulateRainfallStandardEventsSchema {
  return SimulateRainfallStandardEventsSchemaFromJSONTyped(json, false);
}

export function SimulateRainfallStandardEventsSchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SimulateRainfallStandardEventsSchema {
  if (json == null) {
    return json;
  }
  return {
    tag: json["tag"],
    inputs: SimulateRainfallStandardEventsInputFromJSON(json["inputs"]),
    outputs: SimulateRainfallStandardEventsOutputFromJSON(json["outputs"]),
  };
}

export function SimulateRainfallStandardEventsSchemaToJSON(
  json: any
): SimulateRainfallStandardEventsSchema {
  return SimulateRainfallStandardEventsSchemaToJSONTyped(json, false);
}

export function SimulateRainfallStandardEventsSchemaToJSONTyped(
  value?: SimulateRainfallStandardEventsSchema | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    tag: value["tag"],
    inputs: SimulateRainfallStandardEventsInputToJSON(value["inputs"]),
    outputs: SimulateRainfallStandardEventsOutputToJSON(value["outputs"]),
  };
}
